const TYPES_REQUIRING_RELATED_AGREEMENT = ['promotion', 'demand'];

export const requiresRelatedAgreement = (documentType) =>
  TYPES_REQUIRING_RELATED_AGREEMENT.includes(documentType);

export const canManageDocumentVisibility = (documentType, relation) =>
  !requiresRelatedAgreement(documentType) || (Array.isArray(relation) && relation.length > 0);
